import { Api } from "@/services/Api";
import store from "../store";

export default {
  register(data) {
    return Api().post("auth/register", data);
  },
  login(data) {
    return Api().post("auth/login", data);
  },
  verifyEmail(data) {
    return Api().post("auth/verify_email", data);
  },
  sendEmailVerifyCode(data) {
    return Api().post("auth/send_email_verify_code", data);
  },
  sendResetPasswordVerifyCode(data) {
    return Api().post("auth/send_reset_password_verify_code", data);
  },
  resetPassword(data) {
    return Api().post("auth/reset_password", data);
  },
  profile(headers) {
    return Api().get("auth/profile", headers);
  },
  profileDetailed(headers) {
    return Api().get("auth/profile_detailed", headers);
  },
  changeProfilePic(formData) {
    var token = store.state.token;
    const headers = {
      Authorization: "Bearer " + token
    };
    return Api().post("auth/update_profile_picture", formData, {
      headers
    });
  },
  changeProfile(data) {
    var token = store.state.token;
    const headers = {
      Authorization: "Bearer " + token
    };
    return Api().post("auth/update_profile", data, {
      headers
    });
  },
  changeEmail(data) {
    var token = store.state.token;
    const headers = {
      Authorization: "Bearer " + token
    };
    return Api().post("auth/update_email", data, {
      headers
    });
  },
  updatePreferedCurrency(data) {
    var token = store.state.token;
    const headers = {
      Authorization: "Bearer " + token
    };
    return Api().post("auth/update_profile/currency", data, {
      headers
    });
  },
  uploadIdentityFile(formData) {
    var token = store.state.token;
    const headers = {
      Authorization: "Bearer " + token
    };
    return Api().post("auth/upload_identity_file", formData, {
      headers
    });
  },
  acDeactivate(data) {
    var token = store.state.token;
    const headers = {
      Authorization: "Bearer " + token
    };
    return Api().post("auth/deactivate", data, {
      headers
    });
  },
  confirmIdentity(data) {
    var token = store.state.token;
    const headers = {
      Authorization: "Bearer " + token
    };
    return Api().post("auth/confirm_identity", data, {
      headers
    });
  },
  inquireIdentity(data) {
    var token = store.state.token;
    const headers = {
      Authorization: "Bearer " + token
    };
    return Api().post("auth/inquire_identity", data, {
      headers
    });
  },
  getConfirmIdentity(headers) {
    return Api().get("auth/confirm_identity", headers);
  },
  addMessageTopic(data) {
    var token = store.state.token;
    const headers = {
      Authorization: "Bearer " + token
    };
    return Api().post("user/new/topic", data, {
      headers
    });
  },
  addMessage(data) {
    var token = store.state.token;
    const headers = {
      Authorization: "Bearer " + token
    };
    return Api().post("user/new/message", data, {
      headers
    });
  },
  getMessageTopicsCount(headers) {
    return Api().get("user/topics/count", headers);
  },
  getMessageTopics(headers) {
    return Api().get("user/topics", headers);
  },
  getMessageTopic(data) {
    var token = store.state.token;
    const headers = {
      Authorization: "Bearer " + token
    };
    return Api().post("user/topic", data, {
      headers
    });
  }
};
